import mutations from './mutations';
import actions from './actions';

const initialState = {
  loading: false,
  allAvailablePartnersGroups: [],
  partners: [],
  allAvailableUsersGroups: [],
  users: [],
  selectedGroups: [],
  selectedAuthEvents: []
};

const members = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default members;
